var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/dropbox"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dropbox"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0013 6.00127L6.44132 10.0013L3.19132 7.80126C2.61132 7.41126 2.60133 6.57128 3.17133 6.16128L7.00132 3.40127C7.34132 3.16127 7.80133 3.15128 8.14133 3.38128L12.0013 6.00127Z",
    fill: "url(#paint0_linear_19738_71124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.81 7.79881L17.56 9.99882L12 5.99882L15.86 3.38883C16.21 3.15883 16.66 3.15882 17 3.40882L20.83 6.16883C21.4 6.56883 21.39 7.40881 20.81 7.79881Z",
    fill: "url(#paint1_linear_19738_71124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0038 14L7.56382 17L5.00383 15.16L3.16383 13.84C2.60383 13.43 2.61382 12.59 3.18382 12.2L6.43382 10L12.0038 14Z",
    fill: "url(#paint2_linear_19738_71124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.8122 12.2C21.3922 12.59 21.4022 13.43 20.8322 13.84L18.9922 15.16L16.4322 17L11.9922 14L17.5522 10L20.8122 12.2Z",
    fill: "url(#paint3_linear_19738_71124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.68 17.3381C18.81 17.2381 19 17.3381 19 17.4981V18.2281C19 18.6181 18.77 18.9681 18.42 19.1381L12.42 21.9081C12.15 22.0281 11.85 22.0281 11.58 21.9081L5.57999 19.1381C5.22999 18.9681 5 18.6181 5 18.2281V17.4981C5 17.3381 5.18001 17.2381 5.32001 17.3381L7.25 18.7281C7.42 18.8481 7.65001 18.8581 7.82001 18.7381L11.72 16.0981C11.89 15.9881 12.11 15.9881 12.28 16.0981L16.18 18.7381C16.35 18.8581 16.58 18.8481 16.75 18.7281L18.68 17.3381Z",
    fill: "url(#paint4_linear_19738_71124)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19738_71124",
    x1: 2.75,
    y1: 3.21484,
    x2: 12.9527,
    y2: 5.25681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#795EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC5DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19738_71124",
    x1: 12,
    y1: 3.21875,
    x2: 22.202,
    y2: 5.26248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#795EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC5DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19738_71124",
    x1: 2.75,
    y1: 10,
    x2: 12.979,
    y2: 11.9853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#795EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC5DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19738_71124",
    x1: 11.9922,
    y1: 10,
    x2: 22.2288,
    y2: 11.9884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#795EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC5DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19738_71124",
    x1: 5,
    y1: 16.0156,
    x2: 19.3628,
    y2: 20.9503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#795EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC5DE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/dropbox.121495c77f5d3ebcae259e7625f7eb9b.svg";
export { ForwardRef as ReactComponent };